import axios from "axios";
import settings from "utils/settings";
import moment from "moment";

const { apiUrl } = settings;

const jobsUrl = `${apiUrl}jobs`;

export const jobsGet = (includeInactive) =>
    axios.get(
        `${jobsUrl}?includeInactive=${includeInactive}`
    );

export const jobsGetById = (id) =>
    axios.get(`${jobsUrl}/${id}`);

export const jobsGetBySupplierId = (supplierId) =>
    axios.get(`${jobsUrl}?supplierId=${supplierId}`);

export const jobCreate = (data) =>
    axios.post(`${jobsUrl}`, data);

export const jobUpdate = (id, data) =>
    axios.put(`${jobsUrl}/${id}`, data);

export const jobDelete = (id) =>
    axios.delete(`${jobsUrl}/${id}`);

export const fetchJobsRequest = (retailerIdArr = [], startDate, endDate) => {
    const params = [];
    startDate = startDate ? `startDate=${startDate}` : null;
    endDate = endDate ? `endDate=${endDate}` : null;

    if (retailerIdArr.length) {
        retailerIdArr.forEach(retailerId => {
            params.push(`retailerId=${retailerId}`);
        });
    }

    if (startDate !== null) {
        params.push(startDate);
    }
    if (endDate !== null) {
        params.push(endDate);
    }

    const query = params.length > 0 ? `?${params.join("&")}` : "";
    return axios.get(`${jobsUrl}/lookup${query}`);
};

export const fetchHelperJobsRequest = (retailerIdArr = []) => {
    const dateFormat = "YYYY-MM-DD";
    // const startDate = "2010-01-01";
    const startDate = moment()
        .subtract(1, "year")
        .format(dateFormat);
        
    const endDate = moment()
        .add(3, "month")
        .format(dateFormat);
    return fetchJobsRequest(retailerIdArr, startDate, endDate);
};
